module.exports = __webpack_public_path__ + "img/timeout_high_score_cards_thumb.cc3e26fa.png";